<template>
  <v-main id="pages" class="bg">
    <v-img
      :class="{
        'v-image--sm': this.$vuetify.breakpoint.smAndDown,
        'v-image--md': this.$vuetify.breakpoint.mdAndDown,
      }"
      :src="
        isMobile
          ? require(`@/assets/${src || 'tela-login-mobile.svg'}`)
          : require(`@/assets/${src || 'tela-login.svg'}`)
      "
      gradient="to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)"
      min-height="100%"
    >
      <v-responsive
        :style="styles"
        min-height="72.5vh"
        class="d-flex align-center ma-0"
      >
        <router-view />
      </v-responsive>
    </v-img>
  </v-main>
</template>


<style scoped>
.bg {
  background-color: #2d3038;
}
</style>

<script>
export default {
  name: "externalView",

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },

  data: () => ({
    isMobile: false,
    srcs: {
      // "/pages/lock": "lock.jpg",
      "/pages/login": "login.jpg",
      // "/pages/pricing": "pricing.jpg",
      "/pages/register": "register.jpg",
    },
  }),

  computed: {
    src() {
      return this.srcs[this.$route.path];
    },
    styles() {
      const paddingTop = this.$vuetify.breakpoint.mdAndUp ? 120 : 110;
      const paddingBottom = this.$vuetify.breakpoint.mdAndUp ? 100 : 110;
      return {
        padding: `${paddingTop}px 0 ${paddingBottom}px 0`,
      };
    },
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 920;
    },
  },
};
</script>
